import React, { type ComponentProps, type PropsWithChildren } from 'react';
import { type Edge } from 'react-native-safe-area-context';

import { TransparentModal } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderModal = (props: Props) => {
  const { children, accessibilityLabel, size = 'medium', onClose } = props;

  return (
    <TransparentModal
      accessibilityLabel={accessibilityLabel}
      size={size}
      fitHeight
      mobileEdges={MOBILE_SAFE_AREA_EDGES}
      onClose={onClose}
    >
      {children}
    </TransparentModal>
  );
};

// ─── Constants ──────────────────────────────────────────────────────────────

const MOBILE_SAFE_AREA_EDGES: Edge[] = ['top'];

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  accessibilityLabel?: string;
  size?: ComponentProps<typeof TransparentModal>['size'];
  onClose: () => void;
}>;
